module.exports = __webpack_public_path__ + "static/media/palomino-3.f2860e68.jpg";